<div class="news-section">
     <h1 class="header">{{newsPrimary[0]?.title}}</h1>
     <p class="subtitle" [innerHtml]="newsPrimary[0]?.description"></p>
 
    <div class="news-container">
      <!-- Company News -->
      <div class="company-news" *ngIf="companyNews.length >0">
          <h2 style="color: #005eb8;font-size: 20px !important;margin-left: 0px;">{{newsPrimary[1]?.title}}</h2>
        <div class="news-card" *ngFor=" let news of companyNews|slice:0:visibleCount;let i=index">
         <img [src]="news.mediaUrl" alt="Image" class="image-placeholder"/>
          <div class="news-content">
            <h2>{{news?.title}}</h2>
             <!-- <p [innerHtml]="expanded[i] ?news.description:truncated(news.description,200)"></p> -->
                 <p [innerHtml]="expanded[i] ?news.description:truncated(news.description,200)"></p>
            <!-- <div class="read-more"(click)="toggle(i)">{{expanded[i]?'Read Less' :'Read more →'}}</div>  -->
               <div class="read-more"(click)="navigateToTargetLink(news)">{{news?.Button}}</div> 
          </div>
        </div>
 
        <button class="show-more"(click)="showMore()">
              {{allShown ? 'Show less −': 'Show more +'}}
       </button>  
       <div class="linkedin-follow">
           <span>{{newsPrimary[2]?.title}}</span>
          <button class="linkedin-text" (click)="navigateToTargetLink(newsPrimary[2])"> {{newsPrimary[2]?.Button}}<span class="linkedin-logo">in</span>
          </button>
        </div>
      </div>
 
      <!-- Product Recalls -->
      <div class="product-recalls product-recall-section" *ngIf="productRecalls.length>0">
        <h2 [ngStyle]="{'padding-top':isMobileDevice()?'5%':''}" style="color: #005eb8;padding: 0px 15px;font-size: 20px !important">{{ newsPrimary[1]?.description}}</h2>
         <div class="recall-item" *ngFor=" let product of productRecalls|slice:0:recallsCount;let j=index">
           <div class="content-news">
            <h2>{{product?.title}}</h2>
            <p style="font-size: 14px !important;" class="more-read"*ngIf="product.Button" (click)="navigateToTargetLink(product)">{{product?.Button}}</p>
            <p [innerHtml]="expand[j] ?product.description:truncated(product.description,150)"></p>
             <hr class="bottom-line">
          </div>
        </div>
        <button class="more-show" (click)="recallsMore()">
              {{allShow? 'Show less -' : 'Show more +'}}
        </button>  
      </div>
    </div>
</div>
 